import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { Validators, UntypedFormBuilder, ValidationErrors } from '@angular/forms';
import { FunctionsService } from "../../../services/functions.service";
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../../api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AppConstants } from '../../../app.constants';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { StripeService, StripeCardComponent, Element as StripeElement, ElementOptions, ElementsOptions } from "@nomadreservations/ngx-stripe";
import { NgxSpinnerService } from 'ngx-spinner';
import { OkModalComponent } from 'src/app/generic-components/ok-modal/ok-modal.component';

@Component({
    selector: 'app-subscription-purchase',
    templateUrl: './change-plan-prorate.component.html',
    styleUrls: ['./change-plan-prorate.component.css']
})

export class ChangePlanProrateComponent implements OnInit, AfterViewInit {
    @ViewChild(StripeCardComponent) card: StripeCardComponent;
    @ViewChild('tax-row') taxRow: ElementRef;
    stripeKey = '';
    error: any;
    complete = false;
    element: StripeElement;
    model = { options: 'M' };
    cardOptions: ElementOptions = {
        style: {
            base: {
                iconColor: '#276fd3',
                color: '#31325F',
                lineHeight: '40px',
                fontWeight: 300,
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSize: '18px',
                '::placeholder': {
                color: '#CFD7E0'
                }
            },
            invalid: {
                color: '#C12127',
                iconColor: '#C12127'
            }
        }
    };
    language = localStorage.getItem('language')?localStorage.getItem('language'):'en';
    
    elementsOptions: ElementsOptions = {
        locale: (localStorage.getItem('language')=='es')?'es':'en'
    };
    translateFunc:any;
    token:string;
    formSubmitted: boolean = false;
    cart:any;
    tax:any;
    subtotal:any;
    total:any;
    totalNP:any;
    MorY:any;
    cost:any;
    prorateSubtract:any;
    currentInvoice:number = 0;
    disableBtn = false;
    orgProfile:any;
    email:any;
    modalOptions: NgbModalOptions = {};
    zipCode:any;
    withinPR:boolean = false;

    stripe;

    cardErrors;
    cardInfo:any;
  
    loading = false;
    confirmation;

    submitted = false;
    formProcess = false;
    message = "";
    planId:any;
    subscription:any;

    constructor(private apiService: ApiService,
        private formBuilder: UntypedFormBuilder,
        public functionsService:FunctionsService, 
        public router: Router, 
        private route: ActivatedRoute,
        private modalService: NgbModal,
        private translate: TranslateService,
        private _stripe: StripeService,
        private spinner: NgxSpinnerService){
            translate.setDefaultLang('en');
            this.translateFunc = functionsService;
        } 

    upgradeSubscriptionForm = this.formBuilder.group({
        CardName: ['', [Validators.required, Validators.maxLength(26), Validators.pattern(AppConstants.cardNameRegex)]],
        BillingAddress: ['', [Validators.required, Validators.maxLength(100), Validators.pattern(AppConstants.addressRegex)]],
        BillingCity: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingState: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingCountry: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(AppConstants.addressRegex)]],
        BillingCycle: [],
    });

    customStripeForm = this.formBuilder.group({
        cardNumber: [],
        cvv: [],
        expMonth: [],
        expYear: []
    });

    ngOnInit(){
        this.spinner.show();
        this.translate.onLangChange.subscribe(() => {
            if(this.error){
                this.error["message"] = "";
            }
            this.elementsOptions = {
                locale: (localStorage.getItem('language')=='es')?'es':'en'
            };
        });
    }

    ngAfterViewInit(){
        this.getSubscription();
        this.upgradeSubscriptionForm.valueChanges 
            .subscribe(() => {
                 this.disableBtn = this.upgradeSubscriptionForm.valid;
            });
        this.getPreferredCard();
    }

    getSubscription(){
        this.apiService.getCurrentSubscription().subscribe(
            data => {
                this.subscription = data;
                var cycle = this.subscription.cycle;
                if(this.subscription.cycle == "Y"){
                    this.subscription.cycle = "yearly";
                    this.subscription.price = this.subscription.yearlyPrice;
                }else {
                    this.subscription.cycle = "monthly";
                    this.subscription.price = this.subscription.monthlyPrice;
                }

                this.apiService.prorateProcess().subscribe(
                    data => {
                        this.cart = data;
                        this.subtotal = this.cart.price;//this.cart.planMonthlyPrice;
                        this.tax = (this.cart.price * 11.5) / 100;
                        this.total = this.subtotal + this.tax;
                        this.totalNP = this.cart.monthlyPrice;
                        this.MorY = "monthly_price";
                        this.cost = "monthly_cost";
                        this.model = { options: 'M' };
                        this.currentInvoice = (cycle=='M')?this.cart.monthlyPrice:this.cart.yearlyPrice;
                        this.prorateSubtract = (cycle=='M')?(this.cart.monthlyPrice - this.cart.price):(this.cart.yearlyPrice - this.cart.price);
                        this.total = ((this.cardInfo)&&(this.functionsService.checkZipCode(+this.cardInfo.billingZipCode)))?(this.subtotal + this.tax):this.subtotal;
                    }
                );
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
            }
        );
    }

    getPreferredCard(){
        this.apiService.getPreferredCardFull().subscribe(
            data => {
                if(data!=null){
                    switch(data["cardType"]){
                        case "Visa":
                            data["card-fa"] = "fa fa-cc-visa";
                            break;
                        case "MasterCard":
                            data["card-fa"] = "fa fa-cc-mastercard";
                            break;
                        case "Discover":
                            data["card-fa"] = "fa fa-cc-discover";
                            break;
                        case "American Express":
                            data["card-fa"] = "fa fa-cc-amex";
                            break;
                        case "JCB":
                            data["card-fa"] = "fa fa-cc-jcb";
                            break;
                        default:
                            data["card-fa"] = "fa fa-credit-card";
                    }
                    this.cardInfo = data;
                    this.withinPR = this.functionsService.checkZipCode(+this.cardInfo.billingZipCode);
                    this.total = this.withinPR?(this.subtotal + this.tax):this.subtotal;
                }
                this.spinner.hide();
            },
            error => {
                this.functionsService.errorHandler(error["status"]);
                this.spinner.hide();
            }
        );
    }

    upgradeSubscription(){
        document.getElementById("server_error").hidden = true;
        if(this.cardInfo==null){
            if (!this.upgradeSubscriptionForm.valid) {
                Object.keys(this.upgradeSubscriptionForm.controls).forEach(key => {
                const controlErrors: ValidationErrors = this.upgradeSubscriptionForm.get(key).errors;
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach(keyError => {
                    console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                    });
                }
                });
                this.formSubmitted = true;
                return;
            }
            this.spinner.show();
            this._stripe.createToken(this.card.getCard(), { 
                name: this.upgradeSubscriptionForm.value["CardName"], 
                address_line1: this.upgradeSubscriptionForm.value["BillingAddress"],
                address_city: this.upgradeSubscriptionForm.value["BillingCity"],
                address_state: this.upgradeSubscriptionForm.value["BillingState"],
                address_country: this.upgradeSubscriptionForm.value["BillingCountry"],
                currency: "USD"
            })
            .subscribe(result => {
                if (result.token)
                {
                    //Create body content
                    var content:Object = {};
                    content["Tax1"] = this.withinPR?this.tax:0;
                    content["Price"] = this.subtotal;
                    content["Total"] = this.total;
                    content["Result"] = result.token;
                    content["PlanId"] = this.cart.planId;
                    content["Cycle"] = this.upgradeSubscriptionForm.value["BillingCycle"];
                    this.processPayment(content);
                } else if (result.error) {
                    // Error creating the token
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = this.translate.instant('stripe.payment_error');
                    modalRef.componentInstance.message = result.error.message;
                    this.spinner.hide();
                }
            });
        } else{
            this.spinner.show();
            //Send existing cardinfo to process payment
            this.cardInfo.chosenPlan = this.cart.planId;
            this.cardInfo.tax1 = this.withinPR?this.tax:0;
            this.cardInfo.price = this.subtotal;
            this.cardInfo.total = this.total;
            this.cardInfo.cycle = this.upgradeSubscriptionForm.value["BillingCycle"];
            this.apiService.prorateExistingPayment(this.cardInfo).subscribe(
                data => {
                    this.spinner.hide(); 
                    const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                    modalRef.componentInstance.title = this.translate.instant('account.subscription_upgraded');
                    modalRef.componentInstance.message = this.translate.instant('account.payment_processed_existing');
                    this.translate.onLangChange.subscribe(() => {
                        modalRef.componentInstance.title = this.translate.instant('account.subscription_upgraded');
                        modalRef.componentInstance.message = this.translate.instant('account.payment_processed_existing');
                    });
                    this.apiService.getAgentDispatch().subscribe(result => {
                        localStorage.setItem('agentDispatch', result['agentDispatch']);
                        localStorage.setItem('geoAssignment', result['geoAssignment']);
                    });
                    modalRef.result.then(() => {
                        this.router.navigate(['/main'], { relativeTo: this.route });
                    });
                }, 
                error => {
                    if(error["error"]["content"] && error["status"]==400){
                        var exceptionError = error["error"]["content"].split(':');
                        var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                        var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                        document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                        document.getElementById("server_error").hidden = false;
                        this.translate.onLangChange.subscribe(() => {
                            if(error["error"]["content"] && error["status"]==400){
                                var exceptionError = error["error"]["content"].split(':');
                                var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                                var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                                document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                                document.getElementById("server_error").hidden = false;
                            }
                        });
                    }else{
                        this.functionsService.errorHandler(error["status"]);
                    }
                    this.spinner.hide();
                }
            );
        }
    }

    processPayment(content){
        document.getElementById("server_error").hidden = true;
        this.apiService.prorateNewPayment(content).subscribe(
            data => {
                this.spinner.hide();
                const modalRef = this.modalService.open(OkModalComponent, { size: 'lg' });
                modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                modalRef.componentInstance.message = this.translate.instant('account.payment_processed_existing');
                this.translate.onLangChange.subscribe(() => {
                    modalRef.componentInstance.title = this.translate.instant('account.subscription_reactivated');
                    modalRef.componentInstance.message = this.translate.instant('account.payment_processed_existing');
                });
                this.apiService.getAgentDispatch().subscribe(result => {
                    localStorage.setItem('agentDispatch', result['agentDispatch']);
                    localStorage.setItem('geoAssignment', result['geoAssignment']);
                });
                modalRef.result.then(() => {
                    this.router.navigate(['/main'], { relativeTo: this.route });
                });
            }, 
            error => {
                if(error["error"]["content"] && error["status"]==400){
                    var exceptionError = error["error"]["content"].split(':');
                    var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                    var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                    document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                    document.getElementById("server_error").hidden = false;
                    this.translate.onLangChange.subscribe(() => {
                        if(error["error"]["content"] && error["status"]==400){
                            var exceptionError = error["error"]["content"].split(':');
                            var err = exceptionError[1]?exceptionError[1]:exceptionError[0];
                            var message = (exceptionError[0]=="stripe")?(this.translate.instant("stripe."+err)):("exception"?(this.translate.instant(err)):err);
                            document.getElementById("server_error").innerHTML = "*** "+ message + " *** <br><br>";
                            document.getElementById("server_error").hidden = false;
                        }
                    });
                }else{
                    this.functionsService.errorHandler(error["status"]);
                }
                this.spinner.hide(); 
            }
        )
    }
    getBillingQuantity(type){
        if(type=='Y'){
            this.totalNP = this.cart.yearlyPrice; //+ this.tax;
            this.MorY = "yearly_price";
        }else{ //Montly is the default
            this.totalNP = this.cart.monthlyPrice;
            this.MorY = "monthly_price";
        }
    }

    get CardName() { return this.controlGetter('CardName'); }
    get BillingAddress() { return this.controlGetter('BillingAddress'); }
    get BillingCity() { return this.controlGetter('BillingCity'); }
    get BillingState() { return this.controlGetter('BillingState'); }
    get BillingCountry() { return this.controlGetter('BillingCountry'); }
    get BillingCycle() { return this.controlGetter('BillingCycle'); }

    controlGetter(controlName) {
        const control =  this.upgradeSubscriptionForm.get(controlName);
        return control && (control.touched || this.formSubmitted) ? control : {};
    }

    cardUpdated(result) {
        this.zipCode = +result.card.value.postalCode;
        this.withinPR = this.functionsService.checkZipCode(this.zipCode);
        if(this.withinPR){ //Show tax
            this.total = this.subtotal + this.tax;
            document.getElementById("tax-row").style.display = 'flex';
        }
        else{
            this.total = this.subtotal;
            document.getElementById("tax-row").style.display = 'none';
        }
        this.element = result.element;
        this.complete = result.card.complete;
        this.error = undefined;
    }

    keyUpdated() {
    this._stripe.changeKey(this.stripeKey);
    }
}